'use client';

import { useState } from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';

import { Button, Typography } from 'lighthouse';

import { getStrapiImageUrl } from '@/utilities/strapiImageUrl';

import { QuickServiceCell } from './_components/QuickServiceCell';
import classes from './index.module.css';
import { QuickServicesProps } from './models';

const AllServicesModal = dynamic(() => import('./_components/AllServicesModal').then((mod) => mod.AllServicesModal), { ssr: false });

export const QuickServices = ({ services }: QuickServicesProps) => {
    const [isAllServicesOpen, setIsAllServicesOpen] = useState(false);
    const visibleServices = services.slice(0, 7);

    if (!services.length) return null;

    return (
        <section className='relative z-0' aria-label='خدمات ازکی سرویس'>
            <div className={`${classes.dock} rounded-lg border border-white/80 bg-white/60 p-3 backdrop-blur-xl md:p-4`}>
                <div className='relative z-10 mb-3 flex items-center justify-between gap-3 px-1 md:mb-4'>
                    <div className='min-w-0'>
                        <Typography variant='subtitle2' color='blackHighEmphasis' component='h2'>
                            خدمات ازکی سرویس
                        </Typography>
                        <Typography variant='caption' color='blackMediumEmphasis' className='mt-0.5 block'>
                            سرویس موردنظرت رو انتخاب کن و درخواست بده
                        </Typography>
                    </div>
                </div>

                <div className='relative z-10 grid grid-cols-4 items-start gap-1 py-2 md:grid-cols-8 md:gap-2'>
                    {visibleServices.map((service, index) => (
                        <QuickServiceCell
                            key={service.id}
                            title={service.title}
                            href={service.url}
                            imageUrl={service.image?.url ? getStrapiImageUrl(service.image.url) : undefined}
                            index={index}
                        />
                    ))}
                    {services.length > 7 && (
                        <Button
                            variant='text'
                            color='primary'
                            aria-label='مشاهده همه خدمات ازکی سرویس'
                            aria-haspopup='dialog'
                            aria-expanded={isAllServicesOpen}
                            onClick={() => setIsAllServicesOpen(true)}
                            className='group min-w-0 rounded-lg px-1 py-2 hover:!bg-transparent focus-visible:ring-2 focus-visible:ring-primary
                                [&>span]:flex [&>span]:flex-col [&>span]:items-center [&>span]:gap-2'>
                            <span
                                className={`${classes.well} flex h-14 w-14 items-center justify-center overflow-hidden rounded-lg bg-white ring-1
                                ring-N200 transition-transform duration-200 ease-out group-hover:scale-105 group-hover:ring-primary/30 md:h-16
                                md:w-16`}>
                                <Image
                                    src='/images/moreServices.svg'
                                    alt=''
                                    width={36}
                                    height={36}
                                    className='h-8 w-8 object-contain transition-transform duration-200 ease-out group-hover:scale-110 md:h-9 md:w-9'
                                />
                            </span>
                            <Typography
                                variant='caption'
                                className='text-[11px] font-medium leading-4 group-hover:text-primary md:text-xs md:leading-5'>
                                بیشتر
                            </Typography>
                        </Button>
                    )}
                </div>
            </div>
            {isAllServicesOpen && <AllServicesModal services={services} onClose={() => setIsAllServicesOpen(false)} />}
        </section>
    );
};
